import Show from "../../utility/Show";
import { LifeStyleTab } from '../Lifestyle Essentials/lifestyleEssentials';

const AddressInputs = ({ state, dispatch, className="" }) => {
  const { isStandalone, currentTab } = state;

  const tabs = [
    { label: 'Lifestyle Essentials', value: 'lifestyle' },
    { label: 'Neighborhood Vibe', value: 'walkindex' },
  ];

  const isTabActive = (tab) => {
    return currentTab === tab;
  };

  const setCurrentTab = (tab) => {
    dispatch({ type: 'SET_CURRENT_TAB', payload: tab });
    // const distance = isAddressInNYC ? '1' : '3';
    // dispatch({ type: 'SET_CURRENT_DISTANCE', payload: distance });
    dispatch({ type: 'SET_CURRENT_WALKINDX_TYPE', payload: null });
    dispatch({ type: 'RESET_CURRENT_LIFESTYLE_TYPE' });
    dispatch({ type: 'SET_SHOW_COMBINE_SEARCH', payload: false });
    dispatch({ type: 'SET_SHOW_FILTERS', payload: false });
  };

  return (
    <div className={`input-wrapper ${className}`}>
      <Show.When isTrue={!isStandalone}>
        <div className="neighbohood-tab-popup">
          <div className="tabs-wrapper">
            {tabs.map((tab) => (
              <div
                key={tab.value}
                className={`tab-item ${
                  isTabActive(tab.value) ? 'selected' : ''
                }`}
                onClick={() => setCurrentTab(tab.value)}
              >
                {tab.label}
              </div>
            ))}
          </div>
        </div>
      </Show.When>
      <div className="address-list">
        <LifeStyleTab />
        {/* {compareLifeStyleAddress.map((address, addressIndex) => (
          <div key={addressIndex} className={`compare-address-item ${
            isAddressEmpty(address) ? 'empty-address-item' : ''
          }`}>
            <div className="address-item-header">
              <span>
                Address {addressIndex + 1}
                <Show.When isTrue={isAddressEmpty(address)}>
                  <div>---</div>
                </Show.When>
              </span>
              <Show.When isTrue={!isAddressEmpty(address) && addressIndex !== 0}>
                <Minus
                  className="remove-address-icon"
                  onClick={() => handleRemoveAddress(addressIndex)}
                />
              </Show.When>
            </div>
            <Show>
              <Show.When isTrue={isAddressEmpty(address)}>
                <Autocomplete
                  className='compare-address-input'
                  placeholder={`Type an address`}
                  index={addressIndex}
                  onClick={handleAddressClick}
                />
              </Show.When>
            </Show>
            <div className="address-wrapper">
              <span>{address.property}</span>
              <Show.When isTrue={!isAddressEmpty(address)}>
                <Favorite
                    className={`add-to-favorites-icon ${
                      isAddressSaved(address) ? 'added-to-favorites' : ''
                    }`}
                    onClick={() => handleSaveAddressToFavorites(address)}
                  />
              </Show.When>
            </div>
            <Show.When isTrue={!isAddressEmpty(address)}>
              {renderScores(addressIndex)}
            </Show.When>
          </div>
        ))} */}
      </div>
    </div>
  )
};

export default AddressInputs;